import React from "react";
import { Snackbar, SnackbarProps } from "@telegram-apps/telegram-ui";

import {
    IconToastSuccess,
    IconToastFail,
    IconToastGeneral,
} from "@/components/Iconfont/Iconfont";
import clsx from "clsx";

const DefaultBeforeNode = ({
    iconType,
}: {
    iconType: "success" | "error" | "info";
}) => {
    const customBeforeIcon = {
        success: (
            <IconToastSuccess className=" text-white !text-[28px]"></IconToastSuccess>
        ),
        error: (
            <IconToastFail className=" text-white !text-[28px]"></IconToastFail>
        ),
        info: (
            <IconToastGeneral className="text-white !text-[28px]"></IconToastGeneral>
        ),
    };
    return customBeforeIcon[iconType] || customBeforeIcon["info"];
};

const getValue = function () {
    const [snackbar, setSnackbar] = React.useState<
        SnackbarProps & { show: boolean }
    >({
        onClose: () => {},
        before: null,
        show: false,
        duration: 3000,
        description: "",
    });

    const value = {
        snackbar,
        setSnackbar,
        info: (
            description: string,
            options: {
                duration: number;
                onClose: () => void;
                optionClass: string;
            } = { duration: 2000, onClose: () => {}, optionClass: "" }
        ) => {
            setSnackbar({
                ...snackbar,
                before: <DefaultBeforeNode iconType={"info"} />,
                ...options,
                show: true,
                description,
            });
        },
        success: (
            description: string,
            options: {
                duration: number;
                onClose: () => void;
                optionClass: string;
            } = { duration: 2000, onClose: () => {}, optionClass: "" }
        ) => {
            setSnackbar({
                ...snackbar,
                before: <DefaultBeforeNode iconType={"success"} />,
                ...options,
                show: true,
                description,
            });
        },
        error: (
            description: string,
            options: {
                duration: number;
                onClose: () => void;
                optionClass: string;
            } = { duration: 2000, onClose: () => {}, optionClass: "" }
        ) => {
            setSnackbar({
                ...snackbar,
                before: <DefaultBeforeNode iconType={"error"} />,
                ...options,
                show: true,
                description,
            });
        },
    };

    return value;
};

const SnackbarContext = React.createContext<ReturnType<typeof getValue>>(null!);

export const SnackbarProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const value = getValue();
    const { snackbar, setSnackbar } = value;

    return (
        <SnackbarContext.Provider value={value}>
            {children}
            {snackbar.show && (
                <Snackbar
                    duration={snackbar.duration}
                    className={clsx(
                        "_bot_Snackbar z-[99999] fixed  bottom-[30px] font-Semibold text-[50px]"
                    )}
                    description={snackbar.description}
                    before={
                        snackbar.before || (
                            <DefaultBeforeNode iconType={"info"} />
                        )
                    }
                    onClick={() => {
                        snackbar.onClose && snackbar.onClose();
                        setSnackbar((data) => ({
                            ...data,
                            show: false,
                        }));
                    }}
                    onClose={() => {
                        snackbar.onClose && snackbar.onClose();
                        setSnackbar((data) => ({
                            ...data,
                            show: false,
                        }));
                    }}
                ></Snackbar>
            )}
        </SnackbarContext.Provider>
    );
};

export function useSnackbar() {
    return React.useContext(SnackbarContext) as ReturnType<typeof getValue>;
}
